// PdfUpload.js
import React, { useRef, useState } from 'react';
import axios from 'axios';

const PdfUpload = ({ apiEndpoint, lender, object_id, onSuccess, existingStatements = [] }) => {
    const inputRef = useRef(null);
    const [uploading, setUploading] = useState(false);
    const [showPicker, setShowPicker] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const months = [
        { val: 1, label: 'January' },
        { val: 2, label: 'February' },
        { val: 3, label: 'March' },
        { val: 4, label: 'April' },
        { val: 5, label: 'May' },
        { val: 6, label: 'June' },
        { val: 7, label: 'July' },
        { val: 8, label: 'August' },
        { val: 9, label: 'September' },
        { val: 10, label: 'October' },
        { val: 11, label: 'November' },
        { val: 12, label: 'December' }
    ];

    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear; y >= currentYear - 5; y--) {
        years.push(y);
    }

    const isPeriodDisabled = (month, year) => {
        return existingStatements.some(s => s.statement_month_int === month && s.statement_year_int === year && s.has_transactions);
    };

    const openFilePicker = () => {
        if (uploading) return;
        setShowPicker(true);
    };

    const handleConfirm = () => {
        if (isPeriodDisabled(selectedMonth, selectedYear)) {
            alert('A statement for this period has already been uploaded.');
            return;
        }
        if (inputRef.current) inputRef.current.click();
        setShowPicker(false);
    };

    const handleFileChange = async (event) => {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        setUploading(true);
        try {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append('files', files[i]);
            }
            formData.append('lender', lender);
            formData.append('object_id', object_id);
            formData.append('statement_month', selectedMonth);
            formData.append('statement_year', selectedYear);

            const response = await axios.post(apiEndpoint, formData);

            const data = response.data;

            alert(data.message || 'Statements uploaded and parsing started successfully.');
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            console.error('Error uploading files:', error);
            const errorMsg = error.response?.data?.error || error.message || 'An error occurred during upload. Please try again.';
            alert(errorMsg);
        } finally {
            setUploading(false);
            if (inputRef.current) inputRef.current.value = '';
        }
    };

    return (
        <div style={{ position: 'relative' }}>
            <input
                ref={inputRef}
                type="file"
                accept="application/pdf"
                multiple
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
            <button
                type="button"
                className="btn btn-primary"
                onClick={openFilePicker}
                disabled={uploading}
                title="Upload Statements"
                style={{ whiteSpace: 'nowrap' }}
            >
                {uploading ? (
                    <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Uploading...
                    </>
                ) : (
                    'Upload Statements'
                )}
            </button>

            {showPicker && (
                <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    zIndex: 1000,
                    backgroundColor: '#1f2937',
                    border: '1px solid #374151',
                    borderRadius: '8px',
                    padding: '16px',
                    marginTop: '8px',
                    width: '250px',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
                }}>
                    <h6 className="mb-3 text-light">Select Statement Period</h6>
                    <div className="mb-3">
                        <label className="form-label text-muted small">Month</label>
                        <select 
                            className="form-select form-select-sm bg-dark text-light border-secondary"
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                        >
                            {months.map(m => (
                                <option key={m.val} value={m.val} disabled={isPeriodDisabled(m.val, selectedYear)}>
                                    {m.label} {isPeriodDisabled(m.val, selectedYear) ? '(Uploaded)' : ''}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-3">
                        <label className="form-label text-muted small">Year</label>
                        <select 
                            className="form-select form-select-sm bg-dark text-light border-secondary"
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                        >
                            {years.map(y => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </select>
                    </div>
                    <div className="d-flex gap-2 justify-content-end">
                        <button className="btn btn-sm btn-secondary" onClick={() => setShowPicker(false)}>Cancel</button>
                        <button className="btn btn-sm btn-primary" onClick={handleConfirm}>Select File</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PdfUpload;